import { render } from "./process.vue?vue&type=template&id=bf2956f6&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"

import "./process.vue?vue&type=style&index=0&id=bf2956f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf2956f6"

export default script